import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ClickOutSideDirective } from '../../../../ui-components/directives/clickOutSide.directive';
import { ChevronDownIconComponent, CloseIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-dropdown-list',
  imports: [
    ClickOutSideDirective,
    NgTemplateOutlet,
    ChevronDownIconComponent,
    CloseIconComponent,
  ],
  templateUrl: './dropdown-list.component.html',
  styleUrl: './dropdown-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DropdownListComponent {
  menuItems = input.required<unknown[]>();
  menuTemplateRef = input.required<TemplateRef<unknown>>();
  containerRef = input.required<string>();
  menuContainer = viewChild<ElementRef<HTMLElement>>('menuContainer');
  dropdownClass = input<string>('');
  isListPositionTop = signal<boolean>(false);
  menuWidth = input<string>('min(20rem,calc(100vw-1rem))');
  menuHeight = signal<number>(0);
  isMenuOpen = signal(false);
  horizontalShift = signal(0);
  handleMenuToggle = output<boolean>();

  listTitle = input<string>('');
  hasCloseButton = input<boolean>(false);
  dropdownLabel = input<string>();

  toggleMenu(event: MouseEvent | null) {
    const shouldOpen = !this.isMenuOpen();
    const containerElement = (
      document.getElementById(this.containerRef()) as HTMLElement
    ).parentElement as HTMLElement;
    const containerCenter =
      (containerElement.getBoundingClientRect().top +
        containerElement.getBoundingClientRect().bottom) /
      2;
    this.isListPositionTop.set(
      (event?.clientY ?? containerCenter) > containerCenter
    );
    this.horizontalShift.set(0);
    this.isMenuOpen.set(shouldOpen);

    if (shouldOpen) {
      requestAnimationFrame(() => this.adjustMenuPosition());
    }

    this.handleMenuToggle.emit(this.isMenuOpen());
  }

  private adjustMenuPosition() {
    const menuElement = this.menuContainer()?.nativeElement;
    if (!menuElement) {
      return;
    }

    const viewportPadding = 8;
    const rect = menuElement.getBoundingClientRect();

    if (rect.left < viewportPadding) {
      this.horizontalShift.set(viewportPadding - rect.left);
      return;
    }

    if (rect.right > window.innerWidth - viewportPadding) {
      this.horizontalShift.set(
        window.innerWidth - viewportPadding - rect.right
      );
      return;
    }

    this.horizontalShift.set(0);
  }
}
